module.exports = __webpack_public_path__ + "img/zdj.ccf7cf1e.png";